import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {PlaceDetails} from '@Components/google-map/google-map.types';

export interface GoogleMapSelectorModalProps {
  googleMapAPIKey: string;
  setVenue: (place: PlaceDetails | undefined) => void;
  selectedVenue: PlaceDetails | undefined;
  onLoaded?: () => void;
}

export function openGoogleMapSelectorModal(props: GoogleMapSelectorModalProps): void {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.GOOGLE_MAP_SELECTOR_MODAL,
      panelProps: {
        googleMapAPIKey: props.googleMapAPIKey,
        onSelectLocation: props.setVenue,
        defaultSelectedLocation: props.selectedVenue,
        onLoaded: props.onLoaded,
      },
    })
  );
}
